<template>
  <div class="common-footer">
    <div class="footer-container">
      <div class="info-content">
        <div class="contact-info">
          <div class="contact-item" v-for="(item, index) in footerConfig?.scenicList || []" :key="index">
            <img  :src="item.imgUrl" alt="" class="icon" />
            <div class="text-group">
              <div class="label">{{ item.title }}</div>
              <div class="value">{{ item.desc }}</div>
            </div>
          </div>
        </div>

        <div class="social-links">
          <el-tooltip :placement="'top'" effect="light" v-for="(item, index) in footerConfig?.mediaList || []" :key="index" :disabled="!item.codeUrl">
            <div slot="content">
              <img :src="$setUrl(item.codeUrl)" style="width: 120px; height: 120px;" />
            </div>
            <div class="social-item">
              <img :src="item.imgUrl" alt="" class="icon" />
              <div class="name">{{ item.title }}</div>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="copyright">
      <span v-if="footerConfig?.baseInfo">{{ footerConfig?.baseInfo }}</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'common-footer',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('common', ['homeList']),
    footerConfig() {
      const componentContent = this.findDetailContent(this.homeList, '/home', 'footers')
      if (!componentContent) return null
      return componentContent
    },
  },
}
</script>
<style lang="scss" scoped>
.common-footer {
  width: 100%;
  height: 140px;
  color: #ffffff;
  
  .footer-container {
    background-color: #333333;
    height: 100px;
    display: flex;
    align-items: center;
    
    .info-content {
      width: 1320px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .contact-info {
        display: flex;
        gap: 60px;
        
        .contact-item {
          display: flex;
          align-items: center;
          
          .icon {
            width: 48px;
            height: 48px;
            margin-right: 15px;
          }
          
          .text-group {
            display: flex;
            flex-direction: column;
            justify-content: center;
            
            .label {
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 5px;
              color: #eee;
            }
            
            .value {
              font-size: 14px;
              color: #ccc;
            }
          }
        }
      }
      
      .social-links {
        display: flex;
        gap: 40px;
        
        .social-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          
          .icon {
            width: 32px;
            height: 32px;
            margin-bottom: 8px;
          }
          
          .name {
            font-size: 12px;
            color: #ccc;
          }
          
          &:hover {
            .name {
              color: white;
            }
          }
        }
      }
    }
  }

  .copyright {
    background: #222326;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    color: #999;
    
    span {
      padding: 0 15px;
      border-right: 1px solid #666;
      
      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
